import { tsUtils } from '@neo-one/ts-utils';
export const hasNumber = (context, node, type) => tsUtils.type_.hasType(type, (tpe) => isNumber(context, node, tpe));
export const isOnlyNumber = (context, node, type) => tsUtils.type_.isOnlyType(type, (tpe) => isNumber(context, node, tpe));
export const isNumber = (context, node, type) => tsUtils.type_.isNumberish(type) || context.builtins.isType(node, type, 'Fixed');

//# sourceMappingURL=typeTests.js.map
